// import {useEffect,useState} from "react";
// import axios from "axios";
// import {NavLink} from "react-router-dom";

// export default function Sidebar(){

// const [menus,setMenus]=useState([]);

// useEffect(()=>{

// const roleId=localStorage.getItem("id");

// axios

// .get("https://localhost:7038/api/Menu/"+roleId)

// .then(res=>{

// setMenus(res.data);

// })

// },[]);

// const parents=menus.filter(x=>x.parentId==null);

// return(

// <div className="sidebar">

// <ul>

// {

// parents.map(parent=>{

// const child=menus.filter(x=>x.parentId===parent.menuId);

// return(

// <li key={parent.menuId}>

// {

// child.length>0?

// <>

// <a
// data-bs-toggle="collapse"
// href={"#m"+parent.menuId}
// >

// <i className={"bi "+parent.icon}></i>

// {parent.menuName}

// </a>

// <div
// className="collapse"
// id={"m"+parent.menuId}
// >

// <ul>

// {

// child.map(c=>

// <li key={c.menuId}>

// <NavLink to={c.menuUrl}>

// <i className={"bi "+c.icon}></i>

// {c.menuName}

// </NavLink>

// </li>

// )

// }

// </ul>

// </div>

// </>

// :

// <NavLink to={parent.menuUrl}>

// <i className={"bi "+parent.icon}></i>

// {parent.menuName}

// </NavLink>

// }

// </li>

// )

// })

// }

// </ul>

// </div>

// )

// }

//22

import { useEffect, useState } from "react";
//import axios from "axios";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/SideBar.css";
import api from "../api/axios";
//import InstallButton from "../services/InstallButton";
export default function Sidebar() {
  const [menus, setMenus] = useState([]);
  //const [menuId, setmenuId]= useState([]);

  // useEffect(() => {
  //   const roleId = localStorage.getItem("id");
  //   console.log(roleId);
  //   api
  //     .get(`/Menu/${roleId}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       setMenus(res.data);
  //       localStorage.setItem("menus", JSON.stringify(res.data));
  //       const roleId = localStorage.getItem("id");
  //       console.log(roleId);
  //       console.log("id =", localStorage.getItem("id"));
  //       console.log("roleId =", localStorage.getItem("roleId"));
  //     })
  //     .catch((err) => console.log(err));
  // }, []);

  // const parents = menus.filter((x) => x.parentId == null);
  useEffect(() => {
  const roleId = localStorage.getItem("id");

  //const menuId = localStorage.getItem("menuId");

  if (!roleId) {
    console.error("Role ID not found");
    return;
  }

  console.log("Role ID:", roleId);

  api
    .get(`/Menu/${roleId}`)
    .then((res) => {
      setMenus(res.data);

      localStorage.setItem("menus", JSON.stringify(res.data));

      console.log("Menus:", res.data);
    })
    .catch((err) => {
      console.error("Menu API Error:", err);
    });
}, []);

const parents = menus.filter((x) => x.parentId === null);

  return (
 <>
 {/* <InstallButton /> */}

   
      {/* <pre>
{JSON.stringify(menus, null, 2)}
</pre> flex-column*/}
 <ul className="nav">
      {parents.map((parent) => {
        const child = menus.filter((x) => x.parentId === parent.menuId);

        return (
          <li className="nav-item" key={parent.menuId}>
            {child.length > 0 ? (
              <>
                <a
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="collapse"
                  href={`#menu${parent.menuId}`}
                >
                  <i className={`bi ${parent.icon} me-2`}></i>

                  {parent.menuName}
                </a>

                {/* <div className="collapse" id={`menu${parent.menuId}`}>
                  <ul className="nav flex-column ms-3">
                    {child.map((c) => (
                      <li className="nav-item" key={c.menuId}>
                        <NavLink to={c.menuUrl} className="nav-link">
                          <i className={`bi ${c.icon} me-2`}></i>

                          {c.menuName}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div> */}

                <div className="collapse" id={`menu${parent.menuId}`}>
  <ul className="nav flex-column ms-3">
    {child
      .filter((c) => c.isAction !== false)
      .map((c) => (
        <li className="nav-item" key={c.menuId}>
          <NavLink to={c.menuUrl} className="nav-link">
            <i className={`bi ${c.icon} me-2`}></i>
            {c.menuName}
          </NavLink>
        </li>
      ))}
  </ul>
</div>
              </>
            ) : (
              <NavLink to={parent.menuUrl} className="nav-link">
                <i className={`bi ${parent.icon} me-2`}></i>

                {parent.menuName}
              </NavLink>
            )}
          </li>
        );
      })}
    </ul>
    </>
  );
}
